import type { TlsProductSummary } from '../../../types/tls-product-summary'
import { buildTlsProductSummary } from '../../../types/tls-product-summary'

const normalizeTlsProductSummary = function (input: Object): TlsProductSummary {
  let summary = {
    ...buildTlsProductSummary(input.name),
    amount: input.amount,
    contractValidityStart: input.contractValidityStart === null ? null : new Date(input.contractValidityStart),
    contractValidityEnd: input.contractValidityEnd === null ? null : new Date(input.contractValidityEnd),
    productSaleDate: input.productSaleDate === null ? null : new Date(input.productSaleDate),
    productOwnerName: input.productOwnerName,
    retailerName: input.retailerName
  }
  return summary
}

export {
  normalizeTlsProductSummary
}



// WEBPACK FOOTER //
// ./src/services/b2b/normalizer/TlsProductSummaryNormalizer.js